import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { getPageName } from '../../../utils/pageName';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';

export const Footer: FC = () => {
  const sourcePage: string = getPageName();

  return (
    <footer className="modal__footer">
      <FormattedMessage id="login/components/footer/Footer.tsx/1" />{' '}
      <Hyperlink
        href={buildUrlWithParameters('/inscription', {
          source: 'login',
          sourcePage,
        })}
      >
        <FormattedMessage id="login/components/footer/Footer.tsx/2" />
      </Hyperlink>
    </footer>
  );
};
